import { render, staticRenderFns } from "./real-sence-example.vue?vue&type=template&id=7bdd3c41&"
import script from "./real-sence-example.vue?vue&type=script&lang=ts&"
export * from "./real-sence-example.vue?vue&type=script&lang=ts&"
import style0 from "./real-sence-example.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./real-sence-example.vue?vue&type=style&index=1&module=true&lang=stylus&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports